.af{flex:1;}